import React, { Component } from 'react'; 
import { IoLogoWhatsapp } from 'react-icons/io';
import Tooltip from '@mui/material/Tooltip';
import './styles.css'
class Whatsapp extends Component {
    render() {
        return (
          <div className='whats-container'>
            {/* <a href="https://api.whatsapp.com/send?phone=+5516999965857"><IoLogoWhatsapp /></a> */}
            <Tooltip title="WhatsApp" arrow>
              <a href="https://wa.me/5516999745857" target="_blank" rel="noopener noreferrer"><IoLogoWhatsapp /></a>
            </Tooltip>
          </div>
          
        );
      }
  }
  
  export default Whatsapp;